import React from "react";
import { injectIntl } from "react-intl";
import { AuthWrapper } from "../../../components/AuthWrapper/AuthWrapper";
import { ButtonComponent } from "../../../components/Controls/Button/Button";
import history from "../../../routes/history";
import { confirmedResetPassword, logo } from "../../../utils/images";
import "./resetPasswordSuccess.scss"
import { androidIcon } from "../../../utils/images";
import { iosIcon } from "../../../utils/images";

const ResetPasswordSuccessMsg = ({ intl: { messages }, inDialog }) => {
  const renderContent = () => {
    return (
      <div className="text-center reset-success-msg-wrapper">
        {!inDialog && (
          <div className="">
            <img src={logo} alt="logo" width={150} className="mt-4" />
          </div>
        )}
        <img
          src={confirmedResetPassword}
          alt="password reseted successfully"
          width={75}
          className="my-5"
        />
        <p className="h4">{messages.auth.resetPasswordSuccess}</p>
        <ButtonComponent
          content={messages.auth.login}
          variant="contained"
          classes="mx-2 px-5 my-3 form-submit-btn"
          handleClick={() => history.push("/login")}
          color="primary"
        />

        <div className="apps_icons_container">
          <a href="https://play.google.com/store/apps">
            <img
              src={androidIcon}
              alt="googleplay"
              height={60}
            />
          </a>
          <a href="https://apps.apple.com/">
            <img
              src={iosIcon}
              alt="appstore"
              height={60}
            />
          </a>
        </div>
      </div>
    );
  };
  return inDialog ? renderContent() : <AuthWrapper content={renderContent()} />;
};

export default injectIntl(ResetPasswordSuccessMsg);
